import React from "react";
import './ClassTopics.css';

const ClassTopics = () => {
  return (
    <div id="classTopics">
      <br />
      JavaScript
      <ul>
        <li>Arrow Functions</li>
        <li> vanilla + ES6 </li>
        <li> Arrays </li>
        <li>Classes</li>
      </ul>
      React
      <ul>
        <li>JSX</li>
        <li>Components + Props</li>
        <li>Render</li>
        <li>State + LifeCycles</li>



      </ul>
    </div>
  );
};

export default ClassTopics;
